import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  gap: 2rem;
`;

export const StyledWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  width: 100%;
`;

export const StyledInner = styled.div`
  width: 100%;
  display: flex;
  gap: 1rem;
  flex-direction: column;
`;
